import React, { PropTypes } from "react";

import ButtonGroup from "./ButtonGroup";
import Dropdown from "./Dropdown";

import Filter from "../Filter";

const SingleSelect = ({ filter, action, placeholder }) => {
	let Select = ButtonGroup;

	if (filter.options && filter.options.length > 3) {
		Select = Dropdown;
	}

	return (
		<Select
			action={action}
			filter={filter}
			placeholder={placeholder || "Select ..."}
		/>
	);
};

SingleSelect.propTypes = {
	action: PropTypes.func,
	filter: PropTypes.object.isRequired,
	placeholder: PropTypes.string
};

SingleSelect.getLabel = Filter.getLabel;

export default SingleSelect;



// WEBPACK FOOTER //
// ./src/components/filter/filters/single-select/SingleSelect.js